// passkeyRefusalCopy renders a server-side passkey refusal as the reason the
// server actually gave. The enrollment endpoint answers 403 with one of two
// codes — WEBAUTHN_DESKTOP_ONLY (the device) or WEBAUTHN_NOT_REQUIRED (the
// role) — and the copy must follow the CODE, never the status: a role refusal
// rendered as a device restriction told a desktop user to switch to their
// desktop (issue 611 AC.1). Anything else returns null so the caller falls back
// to its own generic copy without asserting a reason it does not know.

import { ApiError } from '../services/api';
import { t } from '../i18n';

export function passkeyRefusalCopy(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  const code = (err.body as { code?: string } | null)?.code;
  switch (code) {
    case 'WEBAUTHN_DESKTOP_ONLY':
      return t('passkeys.error.desktopOnly');
    case 'WEBAUTHN_NOT_REQUIRED':
      return t('passkeys.error.notRequired');
    default:
      return null;
  }
}
